/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import ApplicationDetailsPage from 'domain/recruiting/candidatesApplications/Details';
import ApplicationsPage from 'domain/recruiting/candidatesApplications/List';
import { applicationsRouterPath, useApplicationsRoute } from 'domain/recruiting/candidatesApplications/router';

const ApplicationsRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, singleEntityRoute } = useApplicationsRoute();

  return (
    <ProtectedRouter>
      <Routes>
        <Route path={listRoute} element={<ApplicationsPage />} />
        <Route path={singleEntityRoute} element={<ApplicationDetailsPage />} />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

ApplicationsRouter.getRouterPath = applicationsRouterPath;

export default ApplicationsRouter;
